module.exports = __webpack_public_path__ + "img/Speaker=Kevin Lau.eed99937.png";